import Image from "next/image";

type LogoMarkProps = {
  size?: number;
  className?: string;
  priority?: boolean;
};

export function LogoMark({ size = 40, className = "", priority = false }: LogoMarkProps) {
  return (
    <Image
      src="/images/logo-symbiosis-emblem.webp"
      alt="Logo Symbiosis Paysage Services"
      width={size}
      height={size}
      priority={priority}
      className={`block shrink-0 rounded-full ${className}`}
    />
  );
}
